import { useEffect } from "react";
import { Col,Row } from "reactstrap";
import { Chart as ChartJS } from "chart.js";

const ItemScoreComparisonChart = (props) => {
    const numberOfMonths = props.numberOfMonths;
    const chartData = props.chartData;
    const mfrChartData = chartData?.[0]?.scores?.map((trend) => trend.item_score).slice(0, numberOfMonths).reverse();
    const chartDates = chartData?.[0]?.scores?.map((trend) => trend.period).slice(0, numberOfMonths).reverse();
    const comp1ChartData = chartData?.[1]?.scores?.map((trend) => trend.item_score).slice(0, numberOfMonths).reverse();
    const comp2ChartData = chartData?.[2]?.scores?.map((trend) => trend.item_score).slice(0, numberOfMonths).reverse();
    const comp3ChartData = chartData?.[3]?.scores?.map((trend) => trend.item_score).slice(0, numberOfMonths).reverse();

    const MONTHS = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
      
    const months = (config) => {
        var cfg = config || {};
        var count = cfg.count || 12;
        var section = cfg.section;
        var values = [];
        var i, value;
        var startDate = (chartDates?.length > 0) ? new Date(chartDates[0].split('-')[0], (parseInt(chartDates[0].split('-')[1]) - 1)) : new Date();
      
        for (i = 0; i < count; ++i) {
          value = MONTHS[(startDate.getMonth() + i) % 12];
          values.push(value.substring(0, section) + " '" + chartDates?.[i]?.split('-')[0].substring(2,4));
        }
      
        return values;
      }

    const tableOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false,
          },
          legend: {
              display: false,
          },
          tooltip: {
              enabled: true,
              xAlign: 'center',
              yAlign: 'bottom'
          },
        },
    };

    const setupDataTables = () => {
        var comparisonTableCanvas = document.getElementById("itemScoreComparisonTable");
        var distributorChart = ChartJS.getChart("itemScoreComparisonTable");
        if(distributorChart !== undefined) {
            distributorChart.destroy();
        }
        // eslint-disable-next-line
        var comparisonTable = new ChartJS( comparisonTableCanvas ,{
            type: 'line',
            data: {
                labels: months({count: numberOfMonths, section: 3}), 
                datasets: [
                    {
                        label: 'You',
                        data: mfrChartData,
                        backgroundColor: '#0F1740',
                        borderColor: '#0F1740'
                    },
                    {
                        label: 'Competitor 1',
                        data: comp1ChartData,
                        backgroundColor: '#00A86B',
                        borderColor: '#00A86B'
                    },
                    {
                        label: 'Competitor 2',
                        data: comp2ChartData,
                        backgroundColor: '#00A0FF',
                        borderColor: '#00A0FF'
                    },
                    {
                        label: 'Competitor 3',
                        data: comp3ChartData,
                        backgroundColor: '#CF3F7C',
                        borderColor: '#CF3F7C'
                    }
                ]
            },
            options: tableOptions
        });
    };

    useEffect(() => {
        setupDataTables();
    // eslint-disable-next-line
    }, [mfrChartData, comp1ChartData, comp2ChartData, comp3ChartData]);

    return (
        <Col>
            <Row>
                <Col style={{height: '256px'}}>
                    <canvas id="itemScoreComparisonTable"/>
                </Col>
            </Row>
        </Col>
    )
}

export default ItemScoreComparisonChart;